// Ссылки из поля ввода — те же правила, что в `backend/src/cf2/tools/links.py`:
// сервер проверяет ещё раз, здесь — чтобы подсветить строку с ошибкой сразу.

const INSTAGRAM =
  /^(?:https?:\/\/)?(?:www\.|m\.)?(?:instagram\.com|instagr\.am)\/(?:[A-Za-z0-9_.]{1,30}\/)?(?:p|reels?|tv)\/([A-Za-z0-9_-]{5,40})\/?(?:[?#].*)?$/i

const YT_ID = '([A-Za-z0-9_-]{11})'
const YOUTUBE = [
  new RegExp(`^(?:https?://)?(?:www\\.|m\\.|music\\.)?youtube\\.com/watch/?\\?(?:.*&)?v=${YT_ID}(?:[&#].*)?$`, 'i'),
  new RegExp(`^(?:https?://)?(?:www\\.|m\\.)?youtube\\.com/(?:shorts|live|embed|v)/${YT_ID}/?(?:[?#].*)?$`, 'i'),
  new RegExp(`^(?:https?://)?youtu\\.be/${YT_ID}/?(?:[?#].*)?$`, 'i'),
]

export function instagramCode(url: string): string | null {
  return INSTAGRAM.exec(url.trim())?.[1] ?? null
}

export function youtubeId(url: string): string | null {
  const text = url.trim()
  for (const re of YOUTUBE) {
    const id = re.exec(text)?.[1]
    if (id) return id
  }
  return null
}

export interface ParsedLinks {
  /** Непустые строки как есть. */
  lines: string[]
  /** Коды без повторов, в порядке ввода. */
  ids: string[]
  /** Номера строк (с 1), которые не похожи на ссылку нужного вида. */
  bad: number[]
}

/** Поле «по одной ссылке на строку». Номера плохих строк — как в поле, пустые не считаются ошибкой. */
export function parseLinks(text: string, parse: (url: string) => string | null): ParsedLinks {
  const lines: string[] = []
  const ids: string[] = []
  const bad: number[] = []
  text.split('\n').forEach((raw, i) => {
    const line = raw.trim()
    if (!line) return
    lines.push(line)
    const id = parse(line)
    if (id === null) bad.push(i + 1)
    else if (!ids.includes(id)) ids.push(id)
  })
  return { lines, ids, bad }
}

const num1 = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 1 })

export function formatBytes(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined) return '—'
  if (bytes >= 1024 ** 3) return `${num1.format(bytes / 1024 ** 3)} ГБ`
  if (bytes >= 1024 ** 2) return `${Math.max(1, Math.round(bytes / 1024 ** 2))} МБ`
  return `${Math.max(1, Math.round(bytes / 1024))} КБ`
}

export function formatDuration(seconds: number | null | undefined): string {
  if (!seconds) return ''
  const s = Math.round(seconds)
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  const ss = String(s % 60).padStart(2, '0')
  return h > 0 ? `${h}:${String(m).padStart(2, '0')}:${ss}` : `${m}:${ss}`
}
